export default {
  manualCash: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  revenueByArea: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  revenueByProduct: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  professional: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  professionalKpis: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  dfc: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  revenueAreas: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  filials: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  professionalDre: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  balance: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  team: {
    loading: false,
    lastUpdate: null,
    data: [],
  },

  lastUpdateReference: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  comparative: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  filters: {
    loading: false,
    lastUpdate: null,
    data: {}, // frequency, startDate, endDate, equipe, pj, revenueArea, filial. Rateio, Professional
  },
  comissionBpo: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  dreVersion: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  dreComparative: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  dfcComparative: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  // {{NEXT}}
}
